<template>
  <div>
    <v-head></v-head>
    <div class="detail_bg">
      <img src="../assets/pic03.png" alt="">
      <div class="detail_txt">
        <div class="title">
          基于RFID的接地线管理系统
        </div>
        <div class="txt">
          RFID-based grounding wire management system
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div>
        <div class="title">项目概况</div> 
        <div class="txt">
          <p>基于物联网的变电站挂接地线管理装置的研发成果，由国网上海市电力公司市北供电公司于2021年2月在钱湾站内进行了安装应用试验。</p>
          <p>现场试用效果理想，“基于物联网的变电站挂接地线管理装置”提升了工作人员度接地线的管理达到了提醒以及防误操作的目的，具
              有功耗低，传输效率高，信息反映及时，无线传输数据等特点，设备各项性能指标经过了现场环境的考验。</p>
        </div> 
      </div>
      <div>
        <div class="title">现场图片</div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/img21.png" alt="">
            <div class="txt">
              图一：将抗干扰的高频RFID读写器装设在接地点一侧，根据电站内环境的特殊性，该RFID读写器自带电池，在相比于功耗，内置电池可供连续使用1年左右。
            </div>
          </div>
          <div class="list_one">
            <img src="../assets/img22.png" alt="">
            <div class="txt">
              图二：接地线的和接地点的接头处，加装了一个抗干扰的高频定位芯片。
            </div>
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/img23.png" alt="">
            <div class="txt">
              图三：是改装后的接地线接入接地点上的样子，此时接地线上芯片距离接地点旁高频定位读写器的距离小于3公分，在标签与RFID高频定位读写器接触发出信号后，RFID集中器就会接受到信号数据，通过集中器内部算法处理后再将处理好的数据通过物联网方式发送至服务器。
            </div>
          </div>
          <div class="list_one">
            <img src="../assets/img24.png" alt="">
            <div class="txt">
              图四：为RFID高频信号和物联网通信集中成一个通信辅助箱，箱中集成了物联网通信模块和RFID通信集成模块，RFID标签和RFID高频定位读写器中接收到的高频信号和物联网信号通过通信集成箱的上部信号接收天线和下方信号接收天线来扩大信号接收范围。
            </div>
          </div>
        </div> 
      </div>
    </div>

    <div class="detail_content">
      <div>
        <div class="title">软件运行图示</div> 
        <div class="txt">
          <p>软件分成两个模块，第一个模块为现场展示状态模块，如图5，其目的是安装在现场监控室中，使工作人员能够实时掌握现场接地点是否接入接地线的状态，保障运
行安全。第二个模块为小程序模块，如图6，其作用是可对接地线进行管理（包括质检提示、状态查看、新增/更换接地线），也可以查看电站内是否接入接地线，若有接地
线接入则在页面上提示红色气泡。</p>
        </div> 
      </div>
      <div class="img_one">
          <div class="list_one">
            <img class="img1" src="../assets/img25.png" alt="">
          </div>
          <div class="list_one">
            <img class="img2" src="../assets/img26.png" alt="">
          </div>
        </div> 
    </div>
    <v-foot class="detail_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.detail_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.detail_txt {
  position: absolute;
  top: 280px;
  left: 350px;
  color: #fff ;
}
.detail_txt .title {
  font-size: 58px;
}
.detail_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.detail_text {
  display: flex;
}
.detail_content {
  width: 1000px;
  margin: 0 auto;
  color: #666;
}
.detail_content .title {
  font-size: 24px;
  margin-top: 40px;
}
.detail_content .txt {
  margin-top: 15px;
}
.detail_content .txt p {
  font-size: 16px;
  text-indent: 2em;
  margin-top: 3px
}
.img_one {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 1000px;
  flex: 2;
  justify-content: space-between;
  margin-top: 20px;
}
.img_one img {
  width: 450px;
  height: 380px;
}
.img_one .img1 {
  width: 450px;
  height: 480px;
}
.img_one .img2 {
  width: 320px;
  height: 490px;
}
.img_one .txt {
  margin-top: 6px;
  width: 450px;
  margin-bottom: 10px;
  font-size: 13px;
}


.detail_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/Detail.vue